const FALLBACK_META = {
  strategy: 'personalized',
};

export const getRecommendationSectionCopy = (meta = FALLBACK_META, surface = 'course_tab') => {
  const strategy = meta?.strategy || FALLBACK_META.strategy;
  const isColdStart = strategy === 'cold_start';
  const isPreferenceBased = Boolean(meta?.preferences_applied);

  if (surface === 'dashboard') {
    if (isPreferenceBased) {
      return {
        title: 'Recommended Courses',
        description: 'Based on your selected interests.',
        hint: 'For your interests',
      };
    }

    if (isColdStart) {
      return {
        title: 'New for you',
        description: 'Popular now across the catalog while we learn your interests.',
        hint: 'Popular now',
      };
    }

    return {
      title: 'Recommended Courses',
      description: 'Category-first recommendations from courses you have not enrolled in yet.',
      hint: 'For your interests',
    };
  }

  if (isPreferenceBased) {
    return {
      title: 'Recommended for you',
      description: 'Based on your selected interests.',
      hint: 'New courses for your interests',
    };
  }

  if (isColdStart) {
    return {
      title: 'New for you',
      description: 'Popular now across the catalog while we learn your interests.',
      hint: 'Popular now',
    };
  }

  return {
    title: 'Recommended for you',
    description: 'Based on course category and tags from your learning history.',
    hint: 'New courses for your interests',
  };
};
